import { getQueryVariable } from '../../helpers';
import { Page } from '../enums';

export const getCurrentPage = (): Page => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('page') as Page;
};

export const saveEmail = (email: string, data: any): void => {
  let url = 'https://geoip.solarleadfactory.ai/save-data/?email=';
  url += encodeURIComponent(email);
  url += '&lp-name=' + data.lpWizardId;
  url += '&state=' + data.selectedState;
  url += '&zip=' + data.selectedZipCode;
  url += '&city=' + data.selectedCity;
  url += '&street=' + encodeURIComponent(data.selectedAddress);
  url += '&property_type=' + encodeURIComponent(data.property);
  url += '&shade=' + encodeURIComponent(data.sunlight);
  url += '&ownership_status=' + encodeURIComponent(data.addressOwnership);
  url += '&email-report3=' + (data.sendEmailLink ? '1' : '0');
  url += '&ownership_status=' + encodeURIComponent(data.addressOwnership);
  url += '&electric_utility=' + data.utilityProvider;

  if (getQueryVariable('lsid') !== 'NA') {
    url += '&lsid=' + getQueryVariable('lsid');
  }

  const xmlhttp = new XMLHttpRequest();
  xmlhttp.onreadystatechange = () => {
    if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
    }
  };
  xmlhttp.open('GET', url, true);
  xmlhttp.send();
};

export const validateEmail = (email: string): boolean => {
  return !!String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )?.length;
};

export const convertHomeSizeToEnergyConsumption = (
  homeSize: number
): number => {
  const homeSizes = [
    {
      slab: 1,
      minSqft: 500,
      maxSqft: 1200,
      baseConsumption: 15,
      addOnConsPerSqft: 0.01428,
    },
    {
      slab: 2,
      minSqft: 1200,
      maxSqft: 3400,
      baseConsumption: 25,
      addOnConsPerSqft: 0.00454,
    },
    {
      slab: 3,
      minSqft: 3400,
      maxSqft: 6000,
      baseConsumption: 35,
      addOnConsPerSqft: 0.01115,
    },
  ];
  const hs = homeSizes.find(
    (o) => o.minSqft <= homeSize && homeSize <= o.maxSqft
  );
  const energyConsumption = hs
    ? Math.ceil(
        hs.baseConsumption + (homeSize - hs.minSqft) * hs.addOnConsPerSqft
      )
    : 0;
  return energyConsumption;
};
